import * as React from 'react';
import { useSelector } from 'react-redux';
import { Select } from '../../components/Select';
import { EHouseSorting, HOUSE_SORTINGS } from '../../constants/sort';
import { useHouseSorting } from '../../utils/businessLogic/house';
import { AdaptiveSelect } from '../AdaptiveSelect';
import { prepareItems } from './helpers';
import { IHouse } from '../../types/newbuilding/house';
import { reliableSelector } from '../../selectors/newbuilding';

export interface IHouseSelectProps {
  houseId: number | undefined;
  houses: IHouse[];
  onChange(houseId: number | undefined): void;
}

/* istanbul ignore next */
export function HouseSelect({ houses, houseId, onChange }: IHouseSelectProps) {
  const { sorting, sortedArray, changeSorting } = useHouseSorting(houses);
  const isReliableJK = useSelector(reliableSelector);

  const onHouseItemClick = React.useCallback((id: number | undefined) => onChange(id), [onChange]);
  const onSortingChange = React.useCallback((id: EHouseSorting) => changeSorting(id), [changeSorting]);

  const currentHouse = typeof houseId === 'number' && houses.find(({ houseId: id }) => id === houseId);
  const items = prepareItems(sortedArray, isReliableJK);

  return (
    <Select
      modalTitle="Корпуса"
      modalHeader={<AdaptiveSelect value={sorting} values={HOUSE_SORTINGS} onChange={onSortingChange} />}
      value={currentHouse ? currentHouse.houseName : 'Все корпуса'}
      items={items}
      onItemClick={onHouseItemClick}
    />
  );
}

export const HouseSelectContainer = React.memo(HouseSelect);
